import { colorScales } from "@octopusdeploy/design-system-tokens";
import React from "react";
import { iconStyle, type LiveStatusIconSize } from "../LiveAppIcons";
export function UnavailableIcon(size: LiveStatusIconSize) {
    return (<span role="img" className={iconStyle(size)} style={{ background: colorScales.red[500] }}>
            <em className="fa-solid fa-circle-exclamation"/>
        </span>);
}
